import React from 'react';

import LaptopSolidIcon from '../../shared/icons/laptop-solid-icon';
import StarSolidIcon from '../../shared/icons/star-solid-icon';
import Flag from '../flag/flag';

import { isWebOnlyProduct } from '../../shared/utils/product/product';

import { Maybe, ProductData } from '../../shared/types/graphql-types';

import './product-secondary-flags.scss';

type Position = 'top' | 'bottom';

interface ProductSecondaryFlagsProps {
  hideLabel?: boolean;
  hideWebOnly?: boolean;
  position?: Position;
  product?: Maybe<ProductData>;
}

function ProductSecondaryFlags(props: ProductSecondaryFlagsProps) {
  const {
    hideLabel,
    hideWebOnly = false,
    position = 'bottom',
    product
  } = props;
  const isFleetPreferred = product?.isFleetPreferred;
  const isWebOnly = isWebOnlyProduct(product);
  const labelOnlyFlag = hideLabel ? 'label-only-flag' : '';

  function getAllFlags() {
    const flags: JSX.Element[] = [];

    if (isFleetPreferred) {
      flags.push(
        <Flag
          key="preferred-flag"
          renderIcon={
            <StarSolidIcon
              data-testid="preferred-flag-icon"
              styleName="flag-icon"
            />
          }
          styleName={`flag preferred-flag ${position} ${labelOnlyFlag}`}
        >
          {!hideLabel ? ' Fleet Preferred' : ''}
        </Flag>
      );
    }

    if (isWebOnly && !hideWebOnly) {
      flags.push(
        <Flag
          data-testid="web-only-flag"
          key="web-only-flag"
          renderIcon={
            <LaptopSolidIcon
              data-testid="web-only-flag-icon"
              styleName="flag-icon"
            />
          }
          styleName={`flag online-only-flag ${position} ${labelOnlyFlag}`}
        >
          {!hideLabel ? ' ONLINE ONLY' : ''}
        </Flag>
      );
    }
    return flags;
  }

  return (
    <div
      className="product-secondary-flags"
      data-testid="product-secondary-flags"
      styleName={`container ${position}`}
    >
      {getAllFlags()}
    </div>
  );
}

export default ProductSecondaryFlags;
